declare global {
  interface Window {
    env: Record<keyof EnvType, string>;
  }
}

export type EnvType = {
  VITE_ENV: string;
  VITE_BRANDING_ORGANISATION: string;
  VITE_BACKEND_HOST: string;
  VITE_GRAPHQL_URL: string;
  VITE_PAGE_TITLE_PREFIX: string;
  VITE_AUTH0_DOMAIN: string;
  VITE_AUTH0_CLIENT_ID: string;
  VITE_AUTH0_CALLBACK_URL: string;
  VITE_AUTH0_AUDIENCE: string;
  VITE_AUTH0_ORGANISATION: string;
};

export const env = { ...import.meta.env, ...window.env } satisfies EnvType;
